import React, { useState, useEffect } from "react";
import styles from "../../pages/blogview/BlogView.module.css";
import { Container, Modal, Button } from "react-bootstrap";
import { FaArrowLeft, FaShareAlt } from "react-icons/fa";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../axios";
// Removed: import { AxiosInstance } from "../../axios"; // No longer needed here

const PreviewBlog = ({ blogData }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  const blog = blogData;
  const shareLink = window.location.href;

  // 🔹 Derive IMAGE_BASE_URL dynamically from AxiosInstance baseURL
  const IMAGE_BASE_URL = AxiosInstance.defaults.baseURL.replace("/api", "/");

  const handleCopy = () => {
    try {
      const tempInput = document.createElement("textarea");
      tempInput.value = shareLink;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  if (!blog) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh" }}
      >
        <p className="text-muted fs-4">No blog data available for preview.</p>
      </div>
    );
  }

  let fullCoverImageUrl = blog.cover_image_path;

  // Crucially, correctly form the image URL
  if (blog.cover_image_path) {
    // Check if it's already an absolute URL (like a blob: URL or http/s)
    if (
      blog.cover_image_path.startsWith("blob:") ||
      blog.cover_image_path.startsWith("http://") ||
      blog.cover_image_path.startsWith("https://")
    ) {
      fullCoverImageUrl = blog.cover_image_path;
    } else {
      // It's a relative path, so prepend the hardcoded IMAGE_BASE_URL
      // Ensure there's only one slash between the base URL and the path
      fullCoverImageUrl = `${IMAGE_BASE_URL.replace(
        /\/+$/,
        ""
      )}/${blog.cover_image_path.replace(/^\/+/, "")}`;
    }
  } else {
    // Fallback if no cover_image_path is provided
    fullCoverImageUrl =
      "https://placehold.co/1200x600/E0E0E0/333333?text=No+Image";
  }

  return (
    <Container fluid className={`p-0 m-0 ${styles.blogWrapper}`}>
      {/* Header Section */}
      <div className={styles.headerSection}>
        <div className={`${styles.headerTop} d-flex align-items-center`}>
          {/* <FaArrowLeft
            className={styles.backIcon}
            onClick={() => navigate(-1)} // This will navigate back in browser history
            style={{ cursor: "pointer" }}
            title="Go back"
          /> */}
          <h5 className={styles.headerTitle}>{blog.title}</h5>
        </div>

        <div className={styles.subtitleSection}>
          <p className={`${styles.subtitleText} ${styles.labelText}`}>
            {blog.tagline}
          </p>
        </div>

        <div className={`m-0 ${styles.metaBar} d-flex justify-content-between`}>
          <div>
            <p className={`m-0 ${styles.labelText}`}>
              {blog.author_name}, {blog.author_designation}
            </p>
          </div>
          <div>
            <p className={`m-0 ${styles.labelText}`}>
              {moment(blog.posted_date).format("MMMM D, YYYY")}
            </p>
          </div>
          {/* <div className="d-flex align-items-center gap-2">
            <FaShareAlt
              className={styles.shareIcon}
              title="Share this blog"
              style={{ cursor: "pointer", fontSize: "18px" }}
              onClick={() => setShowShareModal(true)}
            />
          </div> */}
        </div>
      </div>

      {/* Main Content Section */}
      <div className="px-4 py-4">
        <div className="my-3">
          <img
            src={fullCoverImageUrl}
            alt="Blog Cover"
            className={styles.coverImage}
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
              borderRadius: "8px",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://placehold.co/1200x600/E0E0E0/333333?text=Image+Not+Found";
            }}
          />
        </div>

        <div
          className={`${styles.contentText} ${styles.valueText}`}
          dangerouslySetInnerHTML={{ __html: blog.content }}
        ></div>

        <div className={styles.categoryTagWrapper}>
          <div className="row py-2 g-0">
            <div className="col-md-6">
              <div className={styles.labelText}>Category</div>
              <div className={styles.valueText}>
                {blog.category?.map((c) => c.category_name).join(", ") || "N/A"}
              </div>
            </div>
            <div className="col-md-6">
              <div className={styles.labelText}>Tags</div>
              <div className={styles.valueText}>
                {blog.tag?.map((t) => t.tag_name).join(", ") || "N/A"}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Share Modal */}
      <Modal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Share This Blog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-start w-100">
            <div className="position-relative w-100">
              <input
                type="text"
                className="form-control pe-5 rounded-md"
                value={shareLink}
                readOnly
                style={{ backgroundColor: "#f8f9fa", borderColor: "#dee2e6" }}
              />
              <i
                className="bi bi-clipboard position-absolute"
                title="Copy to clipboard"
                onClick={handleCopy}
                style={{
                  top: "50%",
                  right: "12px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#6c757d",
                  fontSize: "1.2rem",
                }}
              ></i>
            </div>

            {copied && (
              <div
                className="text-success mt-2"
                style={{ fontSize: "14px", fontWeight: "500" }}
              >
                Link copied to clipboard!
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowShareModal(false)}
            className="rounded-md"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default PreviewBlog;
